"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketplace = void 0;
const axios_class_1 = require("./axios.class");
const index_1 = require("./index");
class Marketplace {
    /**
     * Fetch Marketplace by client Id.
     */
    async getMarketplaceByClient() {
        const { data } = await axios_class_1.axios.get(`/v1/marketplace/client`);
        return data;
    }
    /**
     * Fetch state of marketplace.
     */
    async getMarketplace(marketplaceId) {
        const { data } = await axios_class_1.axios.get(`/v1/marketplace/${marketplaceId}`);
        return data;
    }
    /**
     * Fetch state of marketplace.
     */
    async getState({ marketplaceId, collectionsIds, countries, from, to, }) {
        const queryParams = {
            collectionsIds: collectionsIds === null || collectionsIds === void 0 ? void 0 : collectionsIds.join(','),
            countries: countries === null || countries === void 0 ? void 0 : countries.join(','),
            from: from === null || from === void 0 ? void 0 : from.toISOString(),
            to: to === null || to === void 0 ? void 0 : to.toISOString(),
        };
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`/v1/marketplace/${marketplaceId}/stats`, queryParams));
        return data;
    }
    /**
     * Fetch transactions of marketplace.
     */
    async getMarketplaceTransactions({ marketplaceId, perPage = 10, page = 0, nftCollections, countries, from, to, search }) {
        const queryParams = {
            perPage: perPage.toString(),
            page: page.toString(),
            nftCollections: nftCollections === null || nftCollections === void 0 ? void 0 : nftCollections.join(','),
            countries: countries === null || countries === void 0 ? void 0 : countries.join(','),
            from: from === null || from === void 0 ? void 0 : from.toISOString(),
            to: to === null || to === void 0 ? void 0 : to.toISOString(),
            search
        };
        const { data } = await axios_class_1.axios.get((0, index_1.buildURL)(`/v1/marketplace/${marketplaceId}/transactions`, queryParams));
        return data;
    }
    async createMarketplace(marketplace) {
        const { data } = await axios_class_1.axios.post(`/v1/marketplace/create`, marketplace);
        return data;
    }
    async updateMarketplace(marketplaceId, marketplace) {
        const { data } = await axios_class_1.axios.post(`/v1/marketplace/${marketplaceId}/update`, marketplace);
        return data;
    }
    async applyMarketplaceTransition(marketplaceId, transition) {
        const { data } = await axios_class_1.axios.post(`/v1/marketplace/${marketplaceId}/${transition}`);
        return data;
    }
    async deleteDraftMarketplace(marketplaceId) {
        const { data } = await axios_class_1.axios.post(`marketplace/${marketplaceId}/delete`);
        return data;
    }
}
exports.marketplace = new Marketplace();
